import { ChartService } from "./services/historical-chart.service"

import { ChartLegendComponent } from "./components/historical-chart/chart-legend/chart-legend.component"
import { SeriesListComponent } from "./components/historical-chart/chart-series/chart-series-list.component"
import { HistoricalChartComponent } from "./components/historical-chart/charts/chart.component"
import { TimeRangeComponent } from "./components/historical-chart/time-range.component/chart-time-range.component"
import { ChartTabsComponent } from "./components/historical-chart/chart-tabs/chart-tabs.component"
import { BubbleComponent } from "./components/bubble-chart/bubble.component";
import { PieChartComponent } from "./components/pie-chart/pie-chart.component";
import { TableChartComponent } from "./components/table-chart/table.component";

import { ChartRouterComponent } from "./chart-router.component"

export class ChartManager {
  constructor(private _chartService:ChartService) { }

  readonly charts = [
    { name: 'tbw-bubble', component: BubbleComponent },
    { name: 'tbw-pie-chart', component: PieChartComponent },
    { name: 'tbw-table-chart', component: TableChartComponent },
    { name: 'tbw-historical-chart', component: HistoricalChartComponent },
    { name: 'tbw-chart-legend', component: ChartLegendComponent },
    { name: 'tbw-chart-series', component: SeriesListComponent },
    { name: 'tbw-chart-time-range', component: TimeRangeComponent },
    { name: 'tbw-chart', component: ChartRouterComponent },
    { name: 'tbw-chart-tabs', component: ChartTabsComponent },
  ]

  init(): void {
    this.#registerComponents()
  }

  #registerComponents() {
    this.charts.forEach(c => window.customElements.define(c.name, c.component))
  }
}
